module.exports = __webpack_public_path__ + "img/top-function-search-detail.ad7b6152.jpg";